import {
    IDatiqTimelineInput,
    emptyDatiqTimelineInput,
} from '@dat/datiq-components-pkg/timeline';
import { Control, Mapper } from '../../../models';

const mapper: Mapper = {
    map: (control: Control): IDatiqTimelineInput => {
        if (control.type !== 'Tabs') throw new Error('Invalid Type');
        return {
            ...emptyDatiqTimelineInput,
            id: control.id,
            name: control.name,
            value: !!control.value
                ? {
                      value: control.value.value,
                      display: control.value.display,
                  }
                : null,
            tabs: control.tabs.map((tab) => ({
                id: tab.id,
                value: tab.value,
                display: tab.display,
            })),
        };
    },
};

export default mapper;
